module.exports = __webpack_public_path__ + "static/media/folder.ee9dd6c8.svg";